import { GET_LEVELPATH_API } from '../utils/api';

export const LOAD_LEVELPATH_REQUEST = '@levelpath/LOAD_LEVELPATH_REQUEST';
export type LEVELPATH_REQUEST = typeof LOAD_LEVELPATH_REQUEST;


export interface LoadLevelpath {
  type: LEVELPATH_REQUEST;
  payload: {
    sublevels: null,
  }
}


export async function loadLevelpath(body: any): Promise<LoadLevelpath> {
  try {
    const response = await GET_LEVELPATH_API(body);
    return {
      type: LOAD_LEVELPATH_REQUEST,
      payload: {
        sublevels: response.data
      }
    };
  } catch (error) {
    return { 
      type: LOAD_LEVELPATH_REQUEST, 
      payload: {
        sublevels: Object(error)
      }
    }
  }
}